import './conversation_attribute_view.js.coffee'


class Customer.BooleanAttributeView extends Customer.ConversationAttributeView
  template: JST['backbone/templates/customer/custom_attributes/boolean']
  className: 'custom-attribute'

  render: ->
    @$el.html(@template(model: @model, viewID: @cid))
    @$el.prepend(@titleView.render().el)
    @

  getAdded: ->
    values = _.difference(@getValue(), @initialValues())
    return null if _.isEmpty(values)

    definition_code: @getDefinitionCode(),
    values: values

  getDeleted: ->
    values = _.difference(@initialValues(), @getValue())
    return null if _.isEmpty(values)

    definition_code: @getDefinitionCode(),
    values: values

  getValue: ->
    if @$el.find("#yes-#{@model.get('definition').get('id')}-#{@cid}").prop('checked')
      [true]
    else if @$el.find("#no-#{@model.get('definition').get('id')}-#{@cid}").prop('checked')
      [false]
    else
      []

  validValue: ->
    true
